module.exports = __webpack_public_path__ + "static/paris-016-0c700e8e91e16fd432ecd78672c26938.jpg";